import React, { useEffect, useState } from "react";
import BlogDetailPage from "../../components/Blog/BlogDetail/blogDetailPage";
import {
  categoryNameListAPI,
  homeImagesAPI,
  blogDetailAPI,
} from "../../../public/constants/constants";
import apiManager from "../../utils/apiManager";
import BlogHeader from "../../components/Blog/blogHeader";
import LoadingIndicator from "../../utils/loadingIndicator";
import { isMobile } from '../../utils/utilityManager';

function blogDetailContainer(props) {

  const [categoryNameList, setcategoryNameList] = useState(null);
  const [homeImages, setHomeImages] = useState(null);
  const [socialIcons, setSocialIcons] = useState(null);
  const [socialShareIcons, setSocialShareIcons] = useState(null);
  const [BlogDetailPageTitle, setBlogDetailPageTitle] = useState(null);
  const [BlogDetailPageDescription, setBlogDetailPageDescription] = useState(null);
  const [BlogDetailPageMetaTitle, setBlogDetailPageMetaTitle] = useState(null);
  const [BlogDetailPageMetaDescription, setBlogDetailPageMetaDescription] = useState(null);
  const [BlogDetailPageBanner, setBlogDetailPageBanner] = useState(null);
  const [BlogDetailPageDate, setBlogDetailPageDate] = useState(null);
  const [HowToSchemaDetails, setHowToSchemaDetails] = useState([]);
  const [HowToSchemaQuestions, setHowToSchemaQuestions] = useState([]);
  const [HowToSchemaSteps, setHowToSchemaSteps] = useState([]);

  
  useEffect(() => {
    getCategoryNameList();
    getHomeImages();
    document.title = BlogDetailPageMetaTitle || '';
    getBlogDetail(props.match.params.id);
  }, [BlogDetailPageMetaTitle]);

  const getCategoryNameList = () => {
    apiManager
      .get(categoryNameListAPI)
      .then(response => {
        setcategoryNameList(response.data.data.taxonomy);
      })
      .catch(error => {
        console.log("error", error);
      });
  };

  const calculateImages = arr => {
    const homePageImages = {};
    homePageImages.homePageBanner = arr.find(
      item => item.slug == "b2c-blogs-home-page-banner"
    );
    homePageImages.homePageLogo = arr.find(
      item => item.slug == "b2c-blogs-home-page-logo"
    );
    homePageImages.emailSubsBanner = arr.find(
      item => item.slug == "b2c-blogs-home-page-email-subscription-banner"
    );
    homePageImages.emailSubsLogo = arr.find(
      item => item.slug == "b2c-blogs-home-page-email-subscription-logo"
    );
    homePageImages.rightArrow = arr.find(
      item => item.slug == "b2c-slider-right-arrow"
    );
    homePageImages.leftArrow = arr.find(
      item => item.slug == "b2c-slider-left-arrow"
    );
    homePageImages.customSection = arr.find(
      item => item.slug == "b2c-custom-section"
    );

    setHomeImages(homePageImages);
  };

  const calculateSocialIcons = arr => {
    const socialIcon = [];

    socialIcon.push(arr.find(item => item.slug == "social-media-facebook"));
    socialIcon.push(arr.find(item => item.slug == "social-media-instagram"));
    socialIcon.push(arr.find(item => item.slug == "social-media-linkedin"));
    // socialIcon.push(arr.find(item => item.slug == "social-media-pinterest"));
    socialIcon.push(arr.find(item => item.slug == "social-media-youtube"));
    // socialIcon.push(arr.find(item => item.slug == "social-media-twitter"));
    setSocialIcons([...socialIcon]);
  };

  const calculateShareSocialIcons = arr => {
    const socialShareIcon = {};
    console.log(arr,'abcdef');
    socialShareIcon.mail = (arr.find(item => item.slug == "share-social-media-mail"));
    socialShareIcon.linkedin = (arr.find(item => item.slug == "share-social-media-linkedin"));
    socialShareIcon.facebook = (arr.find(item => item.slug == "share-social-media-facebook"));
    socialShareIcon.pinterest = (arr.find(item => item.slug == "social-media-pinterest"));
    socialShareIcon.twitter = (arr.find(item => item.slug == "share-social-media-twitter"));
    socialShareIcon.whatsapp = (arr.find(item => item.slug == "share-social-media-whatsapp"));
    setSocialShareIcons(socialShareIcon);
    console.log(socialShareIcon,'socialShareIconsss');
  };





  const getHomeImages = () => {
    apiManager
      .get(homeImagesAPI)
      .then(response => {
        const result = response.data.data;
        console.log("error", result);
        console.log(`Blog title = ${JSON.stringify(props.match.params)}`);
        calculateImages(result);
        calculateSocialIcons(result);
        calculateShareSocialIcons(result);


      })
      .catch(error => {
        console.log("error", error);
      });
  };

  
  const getBlogDetail = id => {
    apiManager
      .get(`${blogDetailAPI  }${id}`)
      .then(response => {
        const detail = response.data.data;
        // props.BlogTitie=(detail[0].title);
        console.log(`this.props.BlogTitie1 = ${detail[0].title}`);
        setBlogDetailPageTitle(detail[0].title);
        setBlogDetailPageDescription(detail[0].short_description);
        setBlogDetailPageMetaTitle(detail[0].metaTitle);
        setBlogDetailPageMetaDescription (detail[0].metaDescription);
        setBlogDetailPageBanner(isMobile?detail[0].banner_rwd.url:detail[0].banner.url);
        // setBlogDetailPageInfo(detail);
        setBlogDetailPageDate(detail[0].date);
        setHowToSchema(detail[0].howToSchemaQuestion,detail[0].howToSchemaSteps)
      })
      .catch(error => {
        console.log("error", error);
      });
  };

  const setHowToSchema = (questions,steps) => {
    if(questions!='' && steps!='' && questions != null && steps != null){

    let questionsArr=questions.split(':');
    let stepsArr=steps.split(':');
    console.log("questionsArr in setHowToSchema = "+JSON.stringify(questionsArr));
    console.log("stepsArr in setHowToSchema = "+JSON.stringify(stepsArr));
    
    if(HowToSchemaQuestions.length==0){
      for(let i=0; i<questionsArr.length; i++) {
        HowToSchemaQuestions.push(questionsArr[i]);
      }
    }
    if(HowToSchemaSteps.length==0){
      for(let j=0; j<stepsArr.length; j++){
        HowToSchemaSteps.push(stepsArr[j]);
      }
    }

  }
  console.log("HowToSchemaQuestions in setHowToSchema = "+JSON.stringify(HowToSchemaQuestions));
  console.log("HowToSchemaSteps in setHowToSchema = "+JSON.stringify(HowToSchemaSteps));

  }

  return (    
    <div className="blog-detail-container">
      <link rel="canonical" href={window.location.href} />
      <meta name="description" content={BlogDetailPageMetaDescription} />
      <h1  style={{display: "none"}}>{BlogDetailPageTitle}</h1>	  
      <script type="application/ld+json">
						{`[{"@context":"http://schema.org/",
            "@type":"Article",            
            "mainEntityOfPage":{"@type":"WebPage","@id":"${window.location.href}"},
            "headline":"${BlogDetailPageTitle}",
            "image":"${BlogDetailPageBanner}",
            "author":{"@type":"Organization","name":"Godrej Interio","url":"https://www.godrejinterio.com/blog"},
            "datePublished":"${BlogDetailPageDate}"
            }]`}
				</script>
      {HowToSchemaQuestions.length>0 && HowToSchemaSteps.length>0 ?
      <>
      <script type="application/ld+json">
      {HowToSchemaQuestions.map((question,index)=>
      HowToSchemaSteps.map((steps,index0)=>
        <>
      {index == index0?
      `${index==0?'[':''}{"@context":"http://schema.org/",
      "@type":"HowTo",
      "name":"${question}",
      "description":"${BlogDetailPageMetaDescription}",
      "image":"${BlogDetailPageBanner}",
      "step":${steps.split("$").map((step,index0)=>
      `${index0==0?'[':''}{
        "@type":"HowToStep",
        "text":"${step}"
        }${steps.split("$").length==1?']':
        steps.split("$").length-1==index0?']':''
      }`
      ) 
      }
      }${HowToSchemaQuestions.length==1?']':
      HowToSchemaQuestions.length-1==index?']':','
    }`
      :''}
      </>      
      )
      )
      }
      </script>
      </>
      :'' 
      }
      
      <nav>
        <BlogHeader
          categoryNameList={categoryNameList}
          homeImages={homeImages}
        />
      </nav>
      {categoryNameList && socialIcons && homeImages && socialShareIcons ? <BlogDetailPage
        id={props.match.params.id}
        categoryNameList={categoryNameList}
        socialIcons={socialIcons}
        homeImages={homeImages}
        socialShareIcons={socialShareIcons}       
      /> : <LoadingIndicator />}
    </div>
  );
}

export default blogDetailContainer;
